export const colors = {
  // Primary Solar Theme Colors
  primary: "#F5A623",
  primaryDark: "#E09000",
  primaryLight: "#FFD180",

  // Navy/Dark Colors
  secondary: "#0A1628",
  secondaryLight: "#1a365d",
  navy: "#2d4a7c",

  // Accent Colors
  accentBlue: "#4A90E2",
  accentGreen: "#2ECC71",
  accentTeal: "#1ABC9C",

  // Neutral Colors
  tertiary: "#F0F2F5",
  primaryBg: "rgba(245, 166, 35, 0.05)",
  primarydark: "rgba(245, 166, 35, 0.75)",
  light: "#F8FAFC",
  white: "#ffffff",
  danger: "#F63232",
  dark: "#0A1628",
  lightdark: "#1a365d",
  lightblue: "#E8F4FD",
  darkGrey: "#5a5a5a",
  border: "#E2E8F0",
  gold: "#F5A623",

  // Gradients
  gradient: "linear-gradient(135deg, #0A1628 0%, #1a365d 50%, #2d4a7c 100%)",
  solarGradient: "linear-gradient(135deg, #F5A623 0%, #E09000 100%)",
  glowGradient: "linear-gradient(180deg, rgba(245, 166, 35, 0.15) 0%, transparent 100%)",
};
